import React from "react";

import {
    CHECK_IN_CATEGORY,
    CHECK_IN_CATEGORY_LIST
} from "./checkIn";
import {
    CategoryButton,
    CategoryIconWrapper,
    CategoryRow
} from "./CheckInControls.styled";

const CheckInCategorySelector = ({
    value,
    onChange,
    categories = CHECK_IN_CATEGORY_LIST
}) => {
    const selectedValue = value || CHECK_IN_CATEGORY.LOCATION;

    return (
        <CategoryRow>
            {categories.map(category => (
                <CategoryButton
                    key={category.id}
                    type="button"
                    $active={selectedValue === category.id}
                    $color={category.color}
                    $softColor={category.softColor}
                    aria-pressed={selectedValue === category.id}
                    onClick={() => onChange(category.id)}
                >
                    <CategoryIconWrapper $color={category.color}>
                        <img src={category.icon} alt="" />
                    </CategoryIconWrapper>
                    {category.label}
                </CategoryButton>
            ))}
        </CategoryRow>
    );
};

export default CheckInCategorySelector;
